export default "__VITE_ASSET__2442117a__"